import { ValueGetterFunc, ValueGetterParams } from 'ag-grid-community';
import { isExpiring } from 'applicationTable/ExternalFilters/ExternalFilters.helpers';
import { flattenItemValues } from 'components/ListFilter/ListFilter.helpers';
import { TApplicationTableStateContextValue } from 'contexts/ApplicationTableStateContext/ApplicationTableStateContext';
import { TFilterItem, TTableFilterName } from 'types';
import {
  APPLICATION_STATUS_FILTERS,
  APPLICATION_TABLE_KEYS,
  EXPIRING_STATUS_VALUES,
  PRODUCT_TYPE_FILTERS,
  TERM_LENGTH_FILTERS,
} from 'utils/applications/applications.config';
import { arraysHaveCommonItem } from 'utils/common/common';

type THandleFilterComparisonParams = {
  filterName: TTableFilterName;
  selectedValues: string[];
  valueGetter: ValueGetterFunc;
  params: ValueGetterParams;
};

export const getFilterSelectItems = (
  filterType: TTableFilterName,
  hasTermLoans = false,
): TFilterItem[] => {
  if (filterType === APPLICATION_TABLE_KEYS.status) {
    return APPLICATION_STATUS_FILTERS();
  }

  if (filterType === APPLICATION_TABLE_KEYS.product_type) {
    return PRODUCT_TYPE_FILTERS(hasTermLoans);
  }

  return TERM_LENGTH_FILTERS(hasTermLoans);
};

export const getAllFilterValues = (
  filterName: TTableFilterName,
  hasTermLoans = false,
) => {
  return flattenItemValues(getFilterSelectItems(filterName, hasTermLoans));
};

export const updateTableFilterLocalState = (
  { saveFilter, removeFilter }: TApplicationTableStateContextValue,
  filter: TTableFilterName,
  selectedValues: string[],
  hasTermLoans = false,
) => {
  if (
    filter === APPLICATION_TABLE_KEYS.status &&
    selectedValues.length === 13
  ) {
    removeFilter(filter);
    return;
  }

  if (
    filter === APPLICATION_TABLE_KEYS.term_length &&
    selectedValues.length === TERM_LENGTH_FILTERS(hasTermLoans).length
  ) {
    removeFilter(filter);
    return;
  }

  if (
    filter === APPLICATION_TABLE_KEYS.product_type &&
    selectedValues.length === PRODUCT_TYPE_FILTERS(hasTermLoans).length
  ) {
    removeFilter(filter);
    return;
  }

  saveFilter(filter, selectedValues);
};

export const handleFilterComparison = ({
  filterName,
  selectedValues,
  valueGetter,
  params,
}: THandleFilterComparisonParams) => {
  switch (filterName) {
    case APPLICATION_TABLE_KEYS.status:
      if (
        selectedValues.includes('isExpiring') &&
        selectedValues.length === EXPIRING_STATUS_VALUES.length
      ) {
        return (
          isExpiring(
            params.data.formal_offer_sets[0]?.formal_offers[0].timeout,
          ) && EXPIRING_STATUS_VALUES.includes(valueGetter(params))
        );
      }
      return selectedValues?.includes(valueGetter(params));

    case APPLICATION_TABLE_KEYS.product_type:
      return arraysHaveCommonItem(
        selectedValues,
        valueGetter(params).split(','),
      );
    case APPLICATION_TABLE_KEYS.term_length:
      return arraysHaveCommonItem(
        selectedValues,
        valueGetter(params).split(','),
      );
  }
};
